// extracted by mini-css-extract-plugin
export var block = "ArticleSummary-Blocks-module--block--PqN0Q";
export var container = "ArticleSummary-Blocks-module--container--mv0pp";